import {post, get} from '@/utils/request'

// 查询分销管理列表 查询分销管理明细列表
export function getDistributionManageAPI(data) {
    return post({
        data,
        url: 'commission/distribution-manage/manageList'
    })
}

// 获取分销类型
export function getDistributionTypeMap(data) {
    return post({
        data,
        url: 'commission/distribution-manage/getDistributionType'
    })
}

// 查询分销配置规则列表（查询分销配置列表）
export function getConfigListAPI(data) {
    return post({
        data,
        url: 'commission/distribution-manage/configList'
    })
}

// 变更规则（更新规则）
export function changeRulesAPI(data) {
    return post({
        data,
        url: 'commission/distribution-manage/updateConfig'
    })
}